import { Button, FlexContainer } from '@cof/omni-react';
import styled from '@emotion/styled';

export const LowerHalf = styled('div')`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;

export const PrimaryHeader = styled('header')`
  width: 100vw;
  background-color: rgba(1, 61, 91, 1);
  color: white;
  padding: 32px 32px 32px;
  margin-bottom: 30px;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  text-align: center;
  line-height: 30px;
`;

export const RoundedPrimaryBtn = styled(Button)`
  border-radius: 2rem;
  background-color: #0f1010;
  color: #fff;
  padding: 16px 32px;
  width: 100%;
  &:hover,
  &:before,
  &:after {
    border: none;
  }
  ,
  &:not(:disabled):focus,
  &:not(:disabled):active,
  &:not(:disabled):hover {
    background-color: #0f1010;
  }
`;

export const RoundedSecondaryBtn = styled(Button)`
  border-radius: 2rem;
  background-color: transparent;
  border: 2px solid #0f1010;
  color: #0f1010;
  padding: 16px 32px;
  width: 100%;
  &:hover,
  &:before,
  &:after {
    border: none;
    background-color: transparent;
  }
  ,
  &:not(:disabled):active,
  &:not(:disabled):focus,
  &:not(:disabled):hover {
    border: 2px solid #0f1010;
    background-color: transparent;
    color: #0f1010;
  }
`;

export const AbsolutePosition = styled('div')<{
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}>`
  position: absolute;
  ${({ top }) =>
    top &&
    `
    top: ${top};
  `};
  ${({ right }) =>
    right &&
    `
    right: ${right};
  `};
  ${({ bottom }) =>
    bottom &&
    `
    bottom: ${bottom};
  `};
  ${({ left }) =>
    left &&
    `
    left: ${left};
  `};
`;

export const AbsolutePositionCenter = styled(AbsolutePosition)`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const TransactionHeader = styled('header')`
  background-color: rgba(1, 61, 91, 1);
  color: white;
  padding: 32px 40px 16px;
  h1 {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    text-align: center;
    line-height: 30px;
  }
`;

export const ButtonContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;
